import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = ''
}: ButtonProps) {
  return <motion.a href="https://noveliahub.com/cart/44086900293668:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-gold hover:bg-gold-hover text-forest font-bold py-4 px-8 rounded-full shadow-lg transition-colors text-lg md:text-xl w-full md:w-auto text-center cursor-pointer ${className}`} data-id="element-12">
      {children}
    </motion.a>;
}